// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","Content":"Content-36e2211g1wmbv5xnavq2v6px2nxur6pdfcj7keupdvhpzj3y8sqtqe9949z9pu15bkx9qnwy4t6zu286bwt1dz1sccqu5xr13m1c8hb","loading":"loading-3nshyvac8b7mmshj77bszhteqwpvxha5udyvmc78svy9fyguwe8yjffy58r83ejpb4p1b9ep2dvghnc5x5f6bcqzc2src7whk77dq69","pulse":"pulse-34ws84yy691f5zms8rnzgd4ea1r3vj2yph55gwy5f2yqaarhz5jwkryehn84uj5c2hdvsm7vwnh8k2ex7xqtvt29wmb7a1zayf3zype"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TermsOfUse/TermsOfUse.module.scss
// module id = 1713
// module chunks = 0